export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9441.8e2c5f63.jpg";